import { PriceCalculator } from './shared/PriceCalculator.js';

export default function updateTotalPriceLogic() {
  const isPresent = document.querySelector('[data-total-added-price]');
  if (!isPresent) {
    return;
  }

  // Simply initialize the global price calculator
  return new PriceCalculator();
}